import { CATEGORY_BG } from "../lib/categories";

export const PeriodicTable = ({ elements, onSelect, highlight }) => {
  return (
    <div className="w-full overflow-x-auto pb-4">
      <div className="min-w-[1100px]">
        <div
          className="grid gap-1"
          style={{
            gridTemplateColumns: "repeat(18, minmax(0, 1fr))",
            gridTemplateRows: "repeat(10, 1fr)",
          }}
        >
          {elements.map((el, idx) => {
            const isDimmed = highlight && !highlight(el);
            const colorCls = CATEGORY_BG[el.cat] || "bg-zinc-200 text-black";
            return (
              <button
                key={el.n}
                data-testid={`periodic-table-element-${el.s}`}
                onClick={() => onSelect(el)}
                style={{
                  gridColumn: el.x,
                  gridRow: el.y,
                  animationDelay: `${Math.min(idx * 8, 400)}ms`,
                }}
                className={`pt-cell aspect-square relative border-2 border-zinc-950 ${colorCls} ${
                  isDimmed ? "opacity-20 grayscale" : "opacity-100"
                } hover:z-10 hover:neo-shadow hover:-translate-y-0.5 transition-all duration-150 group flex flex-col justify-between p-1 sm:p-1.5 text-left`}
              >
                <div className="flex items-start justify-between text-[8px] sm:text-[10px] font-mono leading-none">
                  <span className="font-bold">{el.n}</span>
                  <span className="opacity-70 hidden sm:inline">{el.hazard === "extreme" ? "!!!" : el.hazard === "high" ? "!!" : el.hazard === "warning" ? "!" : ""}</span>
                </div>
                <div className="font-heading font-black text-base sm:text-xl lg:text-2xl text-center leading-none">
                  {el.s}
                </div>
                <div className="font-mono text-[7px] sm:text-[8px] leading-none text-center truncate uppercase tracking-wider">
                  {el.name}
                </div>
              </button>
            );
          })}

          {/* Lanthanide/Actinide labels in the gap */}
          <div
            style={{ gridColumn: "3 / span 1", gridRow: 6 }}
            className="border-2 border-dashed border-zinc-400 flex items-center justify-center text-zinc-500 font-mono text-xs"
          >
            57-71
          </div>
          <div
            style={{ gridColumn: "3 / span 1", gridRow: 7 }}
            className="border-2 border-dashed border-zinc-400 flex items-center justify-center text-zinc-500 font-mono text-xs"
          >
            89-103
          </div>
        </div>
      </div>
    </div>
  );
};
